import { render, staticRenderFns } from "./CollapsableSidebar.vue?vue&type=template&id=56307464&scoped=true"
import script from "./CollapsableSidebar.vue?vue&type=script&lang=js"
export * from "./CollapsableSidebar.vue?vue&type=script&lang=js"
import style0 from "./CollapsableSidebar.vue?vue&type=style&index=0&id=56307464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56307464",
  null
  
)

export default component.exports